import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SingletonSharedData } from '../../js/singletonSharedData';
import { 
	selectConversation,
	newUnifiedInboxMessage, 
	newUnifiedInboxExternalNewMessage, 
	changeStateExternalMessage, 
	updateConvsDeletedByError, 
	resetTimeout, 
	fetchingConversation, 
	createDraftMessage, 
	updateDraftMessage,
	updateDraftAttachments,
	deleteDraftMessage,
	chatConversationRead,
} from '../../redux/actions/A_actions_UnifiedInbox';
import {
	endConversationChat,
	spamConversation,
	unassignConversation,
	discardConversation,
	onSendUnifiedResponse,
	sendDispositionOnWrapUp,
	selectedMessage,
	onSendExternalUnifiedResponse,
	aceptedChat,
	changeStateMultimedia,
	getMoreMessages,
	acceptChatSaveTime,
	changeStateMultimediaAll
} from '../../redux/actions/A_messages_to_SM';
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle';
import UnifiedInbox, { REASSIGNED_TYPES, MEDIATYPE } from 'cw-unified-inbox';
import { Singleton } from '../../js/Singleton';
import {showAdminModal} from "../../redux/actions/A_Admin_Alert_Modal";
import { DialogBox } from 'global-components-library';
import { CAMP_TYPES, CONVERSATION_TYPES, CONVERSATION_TYPES_IDS } from '../../constants';
import { endConversation } from '../../redux/reducers/reducer_unified_inbox';
const langCatalogue = {
	0: 'es',
	1: 'en',
	2: 'pt'
};

export class unifiedInboxContainer extends Component {
	constructor(props) {
		super(props);
		this.language = new Singleton();
		this.sharedData = new SingletonSharedData();
		this.agentData = this.sharedData.getUserData();
		this.generalPermissions = this.sharedData.getGeneralPermissions();
		this.state = {
			id: undefined,
			caption: {},
			unassignData: null,
			spamData: null,
			typeModal: null,
			isFinishedConversation: {id: -1, campType: null},
			isAlertUnassignConversation: false,
			isConnectionLost: false,
			numFiles: 1,
			isUploadSuccessful: false
		};
		let APIFact = new APIFactory();
		this.apiCont = APIFact.buildClient();
	}
	

	getAttachments = (campType, id) => {
		let objectResponse = this.apiCont.getObjectResponse();
		const conversation = this.props.conversations[campType][id];
		const data = {
			ConversationId: id,
			CampType: campType,
			MultimediaType: MEDIATYPE[conversation.type],
			UserId: this.props.userId,
			InboundId: conversation.campaign.id
		};
		this.apiCont.getAttachments(data, objectResponse);
		objectResponse.onError = function (error) {
			console.warn(error);
		};
		objectResponse.onSuccess = function (objResponse) {
			if (objResponse.Response.isDone) {
				let environment = window.location.href.split('/')[0];
				let hostname = environment + '//' + window.location.hostname + '/EmailFiles';
				var file_path = objResponse.Response.ResultInfo.split('$domain$').join(hostname);
				var a = document.createElement('A');
				a.href = file_path;
				a.download = file_path.substr(file_path);
				a.target = '_blank';
				a.rel = 'noopener noreferrer';
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			} else {
				console.log(objResponse.Response.ResultInfo);
			}
		};
	};

	uploadAttachments = (campType, id, fileName, file) => {
		let objectResponse = this.apiCont.getObjectResponse();
		const conversation = this.props.conversations[campType][id];
		const data = {
			MultimediaType: MEDIATYPE[conversation.type],
			UserId: this.props.userId,
			InboundId: conversation.campaign.id,
			ConversationId: id,
			NewFileName: fileName,
			From: conversation.contact.from,
			To: conversation.contact.to,
			ClientName: conversation.contact.name,
			MediaType: file.preview ? file.preview.type : undefined,
			CampType: campType
		};
		if (MEDIATYPE[conversation.type] === 1){
			this.apiCont.uploadAttachmentsChats(file.currentFile, data, objectResponse);
			objectResponse.onError = function (error) {
				console.warn(error);
			};
			objectResponse.onSuccess = (objResponse) => {
				this.setState({ caption: [{ campType, id, name: fileName, url: objResponse.url,type:objResponse.type}] });
				console.log(objResponse);
			};
		}
		else if (MEDIATYPE[conversation.type] < 4) {
			this.apiCont.updloadAttachments(file, data, objectResponse);
			objectResponse.onError = function (error) {
				console.warn(error);
			};
			objectResponse.onSuccess = function (objResponse) {
				console.log(objResponse);
			};
		} else {
			this.apiCont.uploadUnifiedInboxAttachments(file, data, objectResponse);
			objectResponse.onError = function (error) {
				console.warn(error);
			};
            objectResponse.onSuccess = (objResponse) => {
                const newFile = { name: fileName, url: objResponse.data.File, size: objResponse.data.FileSize, type: objResponse.type };
                this.setState(prev => ({ caption: Array.isArray(prev.caption) ? [...prev.caption, newFile] : [newFile], isUploadSuccessful: true }));
				console.log('upload success', objResponse);
			};
		}
	};

	onShowAlertDisconexion = () => {
		this.setState({ isConnectionLost: true });
	}
	onChangeNumFiles = (numFiles) => {
		this.setState({ numFiles: numFiles });
	}

	deleteAttachment = (campType, id, fileName) => {
		let objectResponse = this.apiCont.getObjectResponse();
		const conversation = this.props.conversations[campType][id];
		const data = {
			MultimediaType: MEDIATYPE[conversation.type],
			UserId: this.props.userId,
			InboundId: conversation.campaign.id,
			ConversationId: id,
			FileName: fileName,
			CampType: campType
		};
		if(MEDIATYPE[conversation.type] < 4) this.apiCont.deleteAttachment(data, objectResponse);
		else this.apiCont.deleteUnifiedInboxAttachment(data, objectResponse);
		
		objectResponse.onError = function (error) {
			console.warn(error);
		};
		objectResponse.onSuccess = function (objResponse) {
			console.log(objResponse);
		};
	};

	onFinishHandler = (campType, id, isReassigned) => {
		const conversation = this.props.conversations[campType][id];
		let data = {
			MediaType: MEDIATYPE[conversation.type],
			ConversationId: id,
			MessageId: 0,
			AcdId: conversation.campaign.id,
			ShowWrapUp: isReassigned ? false : conversation.campaign.showWrapUp,
			isReassigned,
			isSendDouble: false,
			IsReassignedByAgent: isReassigned && isReassigned === REASSIGNED_TYPES.BY_AGENT,
			CampType: campType
		};
		if(isReassigned==="byTimeout" && campType !== CAMP_TYPES.OUT){
			this.setState({isAlertUnassignConversation:true});
		}
		
		if(campType != null && (this.state.isFinishedConversation.id !== id || this.state.isFinishedConversation.campType !== campType)){
			this.setState({isFinishedConversation:{id: conversation.id, campType}});
		}else{
			data = {
				...data, isSendDouble:true
			}
		}
		if(MEDIATYPE[conversation.type] === 1 || MEDIATYPE[conversation.type] === 5){
			this.props.onFinish(data);
		}
		this.props.endConversation(data);
	};

	onSendResponseHandler = ({camptype, id, message, messageId, subject, attachments, addresses, IsAzure, fileType}) => {
		const conversation = this.props.conversations[camptype][id];
		let idMessage = conversation.messages.length + 1;
		const data = {
			MediaType: MEDIATYPE[conversation.type],
			ConversationId: id,
			// MessageId: 0,
			AcdId: conversation.campaign.id,
			MessageText: message,
			messageId: MEDIATYPE[conversation.type] > 4 ? idMessage : messageId,
			subject,
			attachments,
			addresses,
			senderName: conversation.campaign.senderName,
			IsAzure: IsAzure,
			MessageType: fileType ? fileType : 'text',
			CamType: camptype != null ? camptype : 0
		};
		if (conversation.type === 'CHAT') {
			this.props.appendAgentMessage({ 
				ServiceType: 0,
				ConversationId: id,
				Message: attachments ? attachments.Url : message,
                Type: fileType ? fileType : 'text',
                origin: 'AGENT',
				CamType: camptype != null ? camptype : 0
		});
		} else if (MEDIATYPE[conversation.type] > 3) {
			let date = new Date();
			this.props.appendAgentExternalMessage({
				ConversationID: id,
				Origin: 2,
				Content: message,
				Date: date,
				UIMessageId: idMessage,
				MessageType: fileType ? fileType : 'text',
				statusMesage: 'sending',
				Attachments: attachments,
				CamType: camptype != null ? camptype : 0
			});
			fileType !== 'text' ? this.setState({ caption: {}}) : null
		}
		this.props.onSendResponse(data);
	};


	onSpamHandler = () => {
		if(this.state.spamData){
			const conversation = this.props.conversations[this.state.spamData.campType][this.state.spamData.id];
			let data;
			if (conversation) {
				data = {
					conversationId: this.state.spamData.id,
					acdID: conversation.campaign.id,
					mediaType: MEDIATYPE[conversation.type] ? MEDIATYPE[conversation.type] : 3,
					messageId: MEDIATYPE[conversation.type] === 5 ? 0 : this.state.spamData.message,
					campType: this.state.spamData.campType
				};
			}
			this.props.onSpam(data);
			this.onCancelRequest();
		}
	};

	handlerRequest = (campType, id, message, type) => {
		const conversation = this.props.conversations[campType][id];

		let mediaType = !conversation ? null : MEDIATYPE[conversation.type] ? MEDIATYPE[conversation.type] : 3;
		
		switch(type){
			case 'unassign':
				this.setState({ unassignData: {campType, id, message}, typeModal: type});

				if(mediaType && (mediaType === MEDIATYPE.MAIL || mediaType === MEDIATYPE.CHAT)){
					this.unAssignMailHandler(conversation, mediaType, message);
				}
				else{
					this.props.onShowAlertModal({
						title: this.language.getText("GUIUnifiedInboxunassingConversationDialogTitle"),
						content: this.language.getText("GUIUnifiedInboxunassingConversationDialogContent"),
						accept: this.language.getText("GUIUnifiedInboxCommonunassign"),
						cancel: this.language.getText("GUIUnifiedInboxCommoncancel"),
						onCancel: () => this.onCancelRequest(),
						onAccept: () =>  this.onAcceptRequest()
					});
				}
				break;
			case 'spam':
				this.setState({spamData: {campType, id, message}, typeModal: type});
				this.props.onShowAlertModal({
					title: this.language.getText("GUIUnifiedInboxspamConversationDialogTitle"),
					content: this.language.getText("GUIUnifiedInboxspamConversationDialogContent"),
					accept: this.language.getText("GUIUnifiedInboxCommonmark"),
					cancel: this.language.getText("GUIUnifiedInboxCommoncancel"),
					onCancel: () => this.onCancelRequest(),
					onAccept: () =>  this.onAcceptRequest()
				})
				break;
			default:
				break;
		}
	}

	onCancelRequest = () => {
		switch(this.state.typeModal){
			case 'unassign':
				this.setState({unassignData: null, typeModal: null});
				break;
			case 'spam':
				this.setState({spamData: null, typeModal: null});
				break;
			default:
				break;
		}
	}

	onAcceptRequest = () => {
		switch(this.state.typeModal){
			case 'unassign':
				this.unAssignHandler()
				break;
			case 'spam':
				this.onSpamHandler()
				break;
			default:
				break;
		}
	}

	unAssignMailHandler = (conversation, mediaType, message) => {
		let data;

		data = {
			conversationId: conversation.id,
			acdID: conversation.campaign.id,
			mediaType: mediaType,
			messageId: message,
			campType: conversation.campType
		};
		conversation.campType ===  MEDIATYPE.CHAT && this.onReadyHandle(conversation.campType, conversation.id);
		this.props.onUnassign(data);
	}

	unAssignHandler = () => {
		if(this.state.unassignData){
			this.onFinishHandler(this.state.unassignData.campType, this.state.unassignData.id, REASSIGNED_TYPES.BY_AGENT);
			this.onCancelRequest();
		}
	};

	onDiscardHandler = (campType, id, message) => {
		const conversation = this.props.conversations[campType][id];
		let data;
		if (conversation) {
			data = {
				conversationId: id,
				acdID: conversation.campaign.id,
				mediaType: MEDIATYPE[conversation.type] ? MEDIATYPE[conversation.type] : 3,
				messageId: message,
				campType: conversation.campType
			};
		}
		if (MEDIATYPE[conversation.type]) {
			this.props.onDiscard(data);
		}
	};

	onSelectedMessageHandler = (campType, id) => {
		if(campType != null && id){
			const conversation = this.props.conversations[campType][id];
			if (conversation && conversation.messages && conversation.messages.length > 0 && MEDIATYPE[conversation.type] < 4) {
				const messageId = conversation.messages[conversation.messages.length - 1].id;
				if (MEDIATYPE[conversation.type] === MEDIATYPE.MAIL) {
					const draftExists = !!this.props.draftMessages[messageId];
					if(!draftExists){
						this.props.onCreateDraftMessage(messageId);
					}
				}
				const data = {
					conversationId: id,
					acdID: conversation.campaign.id,
					mediaType: MEDIATYPE[conversation.type] ? MEDIATYPE[conversation.type] : 3,
					messageId: messageId,
					campType
				};
				this.props.onSelectedMessage(data);
				this.props.onSelect(campType, id);
				if (MEDIATYPE[conversation.type] === MEDIATYPE.CHAT) {
					this.props.onChatConversationRead(id);
				}
			} else {
				this.props.onSelect(campType, id);
				this.props.onChangeStateExternalMessage({ subAction: 'CHANGE_STATE_EXTERL_MESSAGE', ConversationID: id, unreadMessage: false, campType });
			}
		}
	};
	onAceptedChatHandler = (campType, id) => {
		const conversation = this.props.conversations[campType][id];
		const data = {
			MediaType: MEDIATYPE[conversation.type],
			ConversationId: id,
			CampType: campType,
			MessageId: 0,
			AcdId: conversation.campaign.id,
			ChatStarted: true
		};
		this.props.onAceptedChat(data);
	};

	onAcceptChatSaveTimeHandler = (campType, id) => {
		const conversation = this.props.conversations[campType][id];
		const data = {
			ConversationId: id,
			CamId: conversation.campaign.id,
			CampType: campType
		}
		this.props.onAcceptChatSaveTime(data);
	}

	getDataToSend = (conversation) => {
		if(conversation.type === CONVERSATION_TYPES.WHATSAPP){
			return {
				ConversationId: conversation.id,
				Tel: conversation.contact.name,
				CamiId: conversation.campaign.id,
				CamType: conversation.campType,
				onReady: false
			}
		} else {
			return {
				ConversationId: conversation.id,
				MediaType : CONVERSATION_TYPES_IDS[conversation.type],
				CamiId: conversation.campaign.id,
				CamType: conversation.campType,
				ClientAccount: conversation.contact.account,
				AllowCalls: Number(this.generalPermissions[240])
			}
		}
	}

	sendPackage = (conversation) => {
		let data = this.getDataToSend(conversation);
		if(conversation.type === CONVERSATION_TYPES.WHATSAPP){
			this.props.onChangeState(data);
		} else {
			this.props.onChangeStateMultimediaAll(data);
		}
	}

	onDialogHandle = (campType, id) => {
		const conversation = this.props.conversations[campType][id];
		this.sendPackage(conversation)
		this.sharedData.setSelectedConversationId(id);
	};

	onReadyHandle = (campType, id, deleteConvs) => {
		const conversation = this.props.conversations[campType][id];
		this.sendPackage(conversation)
		if(deleteConvs){
			this.removeConvsDeleted();
		}
	}

	removeConvsDeleted = () => {
		setTimeout(() => {
			this.props.onUpdateConvsDeletedByError();
		}, 300);
	}

	closeDialogHandle = () => {
		if(this.props.convsDeletedByError && this.props.convsDeletedByError.length > 0 && this.props.campTypeConvsDeletedByError != null){
			if(this.props.campTypeConvsDeletedByError === this.props.selected.campType && this.props.selected.convId && this.props.convsDeletedByError.includes(this.props.selected.convId.toString())){
				this.onReadyHandle(this.props.selected.campType, this.props.selected.convId, true);
			}else{
				this.removeConvsDeleted();
			}
		}
	}
	onLoadMessagesHandler = (campType, id) => {
		const conversation = this.props.conversations[campType][id];
		const lastConversationIndex = conversation.lastConversations.conversationsDict.findIndex(c => c.ConversationId === conversation.lastConversations.lastIdSearched);
		const idToSearch = conversation.lastConversations.conversationsDict[lastConversationIndex].ConversationId;
		const data = {
			MediaType: MEDIATYPE[conversation.type],
			LastConversationId: idToSearch,
			ConversationId: id,
			CampType: conversation.lastConversations.lastIdCampType,
		};
		this.props.onLoadMessages(data);
		setTimeout(() => {
			this.props.onFetchingConversation({campType, id: id, fetching: true})
		}, 500);
	}

	onResetTimeoutHandle = (campType, id) => {
		const data = {
			conversationId: id,
			campType
		}
		this.props.onResetTimeout(data)
	}
	
	onWrapUp = (camptype, id, disposition) => {
		const dispositionData = {
			...disposition,
			id,
			camptype
		}
		this.props.onWrapUp(dispositionData);
	}

	getUploadState = () => {
		return this.state.isUploadSuccessful;
	}

	render() {
		const { conversations, showWrapUp, wrapUpTime, draftMessages } = this.props;
		const { Login, Nombres, ApellidoMaterno, ApellidoPaterno } = this.agentData;
		const titleTabBar = ['Home', 'Twitter', 'Mail', 'Chat', 'WhatsApp'];
		console.log("convs", [...Object.values(conversations[0]), ...Object.values(conversations[1])])
		return (
			<div id='unifiedInboxContainer'>
				<UnifiedInbox
					titleTabBar={titleTabBar}
					agent={{ name: `${Nombres} ${ApellidoPaterno} ${ApellidoMaterno}`, username: Login }}
					conversations={[...Object.values(conversations[0]), ...Object.values(conversations[1])]}
					draftMessages={draftMessages}
					showWrapUp={showWrapUp}
					wrapUpTime={wrapUpTime}
					lang={langCatalogue[this.props.lang]}
					selected={this.props.selected}
					onSelect={this.onSelectedMessageHandler}
					onFinish={this.onFinishHandler}
					onWrapUp={this.onWrapUp}
					onSpam={(campType, id, message) => this.handlerRequest(campType, id, message, 'spam')}
					onUnassign={(campType, id, message) => this.handlerRequest(campType, id, message, 'unassign')}
					onDiscard={this.onDiscardHandler}
					onSendResponse={this.onSendResponseHandler}
					onAttachments={this.getAttachments}
					onUploadAttachments={this.uploadAttachments}
					onDeleteAttachment={this.deleteAttachment}
					onShowAlertDisconexion={this.onShowAlertDisconexion}
					onAceptedChat={this.onAceptedChatHandler}
					onDialog={this.onDialogHandle}
					onReady={this.onReadyHandle}
					setTheUrlOfAttachments={this.state.caption}
					onAcceptChatSaveTime={this.onAcceptChatSaveTimeHandler}
					onResetAgentTimeout={this.onResetTimeoutHandle}
					onLoadMessages={this.onLoadMessagesHandler}
					disabledActions={this.props.errorMCS}
					onUpdateDraftMessage={this.props.onUpdateDraftMessage}
					onUpdateDraftAttachments={this.props.onUpdateDraftAttachments}
					onDeleteDraftMessage={this.props.onDeleteDraftMessage}
					setNumFiles={this.onChangeNumFiles}
					getUploadState={this.getUploadState}
				/>
				<DialogBox
					title={this.language.getText(this.state.numFiles > 1 ? 'GUIAttachamentstitleToFiles' : 'GUIAttachamentstitleToFile')}
					content={this.language.getText("error-9")}
					show={this.state.isConnectionLost}
					toggle={() => this.setState({ isConnectionLost: !this.state.isConnectionLost})}
					accept={this.language.getText('GUIErrorMessageclose')}	
				/>
				<DialogBox
				show={this.state.isAlertUnassignConversation}
				toggle={() => this.setState({ isAlertUnassignConversation: !this.state.isAlertUnassignConversation})}
				title={this.language.getText("GUIUnifiedInboxTitleUnassignConversation")}
				content={this.language.getText("GUIUnifiedInboxBodyUnassignConversation")}
				accept={this.language.getText("GUIUnifiedInboxAceptUnassignConversation")}
				/>	
				<DialogBox title={this.language.getText("GUIUnifiedInboxdeleteConversationsTitle")} content={this.language.getText("GUIUnifiedInboxdeleteConversationsContent")} show={this.props.convsDeletedByError && this.props.convsDeletedByError.length > 0} onAccept={() => this.closeDialogHandle()} accept={this.language.getText("GUIUnifiedInboxCommonclose")} />
			</div>
		);
	}
}

const mapStateToProps = state => ({
	conversations: state.unifiedInboxState.conversations,
	showWrapUp: state.unifiedInboxState.showWrapUp,
	wrapUpTime: state.unifiedInboxState.wrapUpTime,
	selected: state.unifiedInboxState.selected,
	convsDeletedByError: state.unifiedInboxState.convsDeletedByError,
	campTypeConvsDeletedByError: state.unifiedInboxState.campTypeConvsDeletedByError,
	errorMCS: state.unifiedInboxState.errorMMC,
	draftMessages: state.unifiedInboxState.draftMessages,
});

const mapDispatchToProps = {
	onShowAlertModal: payload => showAdminModal(payload),
	onFinish: data => endConversationChat(data),
	onAceptedChat: data => aceptedChat(data),
	onSelect: (campType, id) => selectConversation(campType, id),
	onSpam: data => spamConversation(data),
	onWrapUp: data => sendDispositionOnWrapUp(data),
	onSendResponse: data => onSendUnifiedResponse(data),
	onSendExternalResponse: data => onSendExternalUnifiedResponse(data),
	onUnassign: data => unassignConversation(data),
	onDiscard: data => discardConversation(data),
	onSelectedMessage: data => selectedMessage(data),
	appendAgentMessage: (data, agent) => newUnifiedInboxMessage(data, agent),
	appendAgentExternalMessage: data => newUnifiedInboxExternalNewMessage(data),
	onChangeStateExternalMessage: data => changeStateExternalMessage(data),
	onChangeState: data => changeStateMultimedia(data),
	onChangeStateMultimediaAll: data => changeStateMultimediaAll(data),
	onUpdateConvsDeletedByError: () => updateConvsDeletedByError(),
	onLoadMessages: data => getMoreMessages(data),
	onAcceptChatSaveTime: data => acceptChatSaveTime(data),
	onResetTimeout: data => resetTimeout(data),
	onFetchingConversation: data => fetchingConversation(data),
	onCreateDraftMessage: (id) => createDraftMessage(id),
	onUpdateDraftMessage: (id, data) => updateDraftMessage(id, data),
	onUpdateDraftAttachments: (id, data) => updateDraftAttachments(id, data),
	onDeleteDraftMessage: (id) => deleteDraftMessage(id),
	onChatConversationRead: (campType, id) => chatConversationRead(campType, id),
	endConversation: (data) => endConversation(data)
};

export default connect(mapStateToProps, mapDispatchToProps)(unifiedInboxContainer);



// WEBPACK FOOTER //
// ./src/components/workSpace/unifiedInboxContainer.jsx